import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie } from "src/utils/cookieUtil";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";

const serverIp = process.env.REACT_APP_SERVER_IP;

export const redeemAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  reducerPath: "redeemAPI",
  endpoints: (builder) => ({
    // 재이행 이력 조회
    redeemHistory: builder.query({
      query: (img_idx) => ({
        url: `notice/re-execute-list/${img_idx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // 매장 재이행 등록
    applyRedeem: builder.mutation({
      query: ({ re_execute_idx, data }) => ({
        url: `notice/store/re-execute/${re_execute_idx}`,
        method: "POST",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // 매장 재이행 수정
    modifyRedeem: builder.mutation({
      query: ({ re_execute_idx, data }) => ({
        url: `notice/store/re-execute/${re_execute_idx}`,
        method: "PUT",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // 본사 재이행 수정
    vmdModifyRedeem: builder.mutation({
      query: ({ re_execute_idx, data }) => ({
        url: `notice/vmd/re-execute/${re_execute_idx}`,
        method: "PUT",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // 본사 재이행 삭제
    vmdDeleteRedeem: builder.mutation({
      query: ({ re_execute_idx }) => ({
        url: `notice/vmd/re-execute/${re_execute_idx}`,
        method: "DELETE",
        headers: {
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // 본사 재이행 재요청
    requestReRedeem: builder.mutation({
      query: ({ re_execute_idx, data }) => ({
        url: `notice/execute/${re_execute_idx}/request-re-execute`,
        method: "POST",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // 본사 재이행 확인(요청종료)
    applyEConfirm: builder.mutation({
      query: ({ re_execute_idx }) => ({
        url: `notice/re-execute/${re_execute_idx}/approve`,
        method: "PUT",
        headers: {
          Accept: "*/*, text/plain",
        },
      }),
    }),
  }),
});

export const {
  useRedeemHistoryQuery,
  useApplyRedeemMutation,
  useModifyRedeemMutation,
  useRequestReRedeemMutation,
  useApplyEConfirmMutation,
  useVmdModifyRedeemMutation,
  useVmdDeleteRedeemMutation,
} = redeemAPI;
